export const VOTE_COUNT_THRESHOLD_LOW = 1000
export const VOTE_COUNT_THRESHOLD_MID = 15000
export const VOTE_COUNT_THRESHOLD_HIGH = 50000

export const WEIGHT_ORIGINAL_TAG = 500
export const WEIGHT_CLUSTER_TAG_PRIMARY = 20
export const WEIGHT_CLUSTER_TAG_SECONDARY = 1

export const DISCOVER_PAGE_SIZE = 40
